import { useState } from "react";
import { useDispatch } from "react-redux"
import { store } from 'Store';
import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { setGlobalErrorStatus, setGlobalSuccessStatus, setGlobalWarningStatus, setBatchErrorStatus } from 'Components/StatusHandling'
import { BATCH_ERROR_MESSAGES, ERROR_MESSAGES, WARNING_MESSAGES } from "Utils/constants";
import { Col } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import ConfirmDeleteBatchPopup from "../Popup/ConfirmDeleteBatchPopup";
import { ICONS } from "Utils/icons";

const PSETestBatchCompleted = () => {

  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {
    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();
    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  const completedPSETestBatchHeader = "Processed Test Data Submissions";
  const completedPSETestBatchSearchFieldText = "Search by ID";
  const [completedPSETestBatchSortColumn, setCompletedPSETestBatchSortColumn] = useState({
    sortField: "submitDate",
    sortDirection: "desc"
  });

  // Flag: trigger api to reload data
  const [reloadCompletedPSETestBatch, setReloadCompletedPSETestBatch] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("printout rowName", rowName);
      return { id: rowName.id };
    }
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "submitPsoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/displayBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Setting", columnName: "cfSetting", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "No of Files", columnName: "fileCount", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Accepted", columnName: "totalAccepted", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Rejected", columnName: "rejected", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 5, formatFunction: handleDateFormat, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Report", columnName: "viewReport", selectedRows: selectedList, sortable: false, sortFieldNum: 6, isButton: true, buttonData: { action: handleFileDownload, text: "Download", icon: ICONS.download }, sortingInfo: sortingInfo, title: 'Download Report to View' }));

    return listColumns;
  }

  const handleFileDownload = async (row/*, batchId, fileName*/) => {
    //console.log("handleFileDownload", row);
    //var batchId = row.id;
    const res = await submitDownload(row.id, row.cfSetting);

    if (res) {
      // get filename from the res content-disposition
      const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  const submitDownload = async (batchId, cfSetting) => {
    // reference to ReportRequest.java
    const call = {
      batchId: batchId,
      isTestSubmission: "Y",
      settingName: cfSetting
    }

    const url = '/api/report/batchDetail';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  const submitDeletedBatches = async (batchIdList) => {
    const call = {
      batchId: batchIdList,
    }

    const url = '/api/cda/deleteBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error submitDeletedBatches()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  // Delete completed PSE Test Batch
  const deleteCompletedPSETestBatch = async () => {

    const batchIdList = selected.selectedRows?.map((item) => item.id);
    const res = await submitDeletedBatches(batchIdList);
    //console.log("print out deleteCompletedPSETestBatch batchlist", res);
    if (res?.status == -1) {
      let msg = res?.globalErrorMessageList;
      msg.unshift(res?.message);
      // set error popup    
      setBatchErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          //title: ERROR_MESSAGES.DATA_ERROR.title,
          title: "Error",
          msg: msg,
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
      return;
    } else if (res?.status == -4) {
      //message: globalErrorMessageList + message
      let msg = res?.globalErrorMessageList;
      msg.unshift(res?.message);
      // set warning popup
      setGlobalWarningStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: WARNING_MESSAGES.WARNING.title,
          msg: msg,
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
      // refresh datatable
      setReloadCompletedPSETestBatch(true);
      return;
    }

    // refresh datatable
    setReloadCompletedPSETestBatch(true);
    // set success popup
    setGlobalSuccessStatus({
      dispatch: dispatch,
      popupData: {
        visible: true,
        title: "Success!",
        msg: res.message,
        showContactHelp: false
      },
      redirect: {
        redirect: false,
        redirectFirst: false,
        path: "",
        data: {}
      }
    })

  }

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "Y"
    }
    //console.log("CALL", call);
    var url = '/api/cda/completedBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    });

  const getDeleteBatchesText = () => {
    if (selected.selectedCount > 1) {
      return "Delete Selected Batch(es)";
    }
    else {
      return "Delete Selected Batch";
    }
  }

  const handleShowDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }

  return (
    <>
      <ConfirmDeleteBatchPopup
        show={showDeletePopup}
        handleClose={handleCloseDeletePopup}
        handleDelete={deleteCompletedPSETestBatch}
        selected={selected}
      >
      </ConfirmDeleteBatchPopup>
      <DatatableBase
        tableClassName="cdaTestCompletedTable"
        reload={reloadCompletedPSETestBatch}
        setReload={setReloadCompletedPSETestBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        hasSelectableRows={true}
        searchFieldText={completedPSETestBatchSearchFieldText}
        datatableHeader={completedPSETestBatchHeader}
        datatableDescription={null}
        sortingColumn={completedPSETestBatchSortColumn.sortField}
        sortingOrder={completedPSETestBatchSortColumn.sortDirection}
      >
        {
          <Col className="d-flex justify-content-end ">
            {/* <TextButton className="ms-auto" onClick={deleteCompletedPSETestBatch} variant="normal" content={getDeleteBatchesText()} disabled={selected.selectedCount < 1 ? true : false} /> */}
            <TextButton className="ms-auto" onClick={handleShowDeletePopup} variant="normal" content={getDeleteBatchesText()} disabled={selected.selectedCount < 1 ? true : false} />
          </Col>
        }
      </DatatableBase>
    </>
  )
}

export default PSETestBatchCompleted;